<!--
================================================
Un composant affichant la liste des projets auxquels l'utilisateur à accès

Url d'accès :
http://localhost:8080/fr/cronocloud-inc/projects


LIMITATION DU COMPOSANT :
* La méthode LoadProjects() appele une route de l'api nécéssitant le slug utilisateur, celui-ci étant dispo dans le store mais pas au moment du callback mounted(), l'appel du chargement initial des projets est effectué dans un watcher sur la propriété user (dès que user change et qu'il n'est pas null). Ce n'est pas idéal mais cela fonctionne.

  @since 0.17.1 | IL FAUT CEPENDANT TOUT DE MÊME CHARGER LES PROJETS DANS LE mounted() (fix du bug https://gitlab.com/ousmane1/kronocloud/-/issues/332)

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="ProjectListComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
<!--        {{'Hello ! :) I am ' + $options.name}} <br> count : {{projectCount}} <br>-->

      <!--  Bloc affiché en cas d'absence de projet-->
        <empty-view-bloc-comp
            v-show="projectCount==0 && componentIsReady"
            v-bind:emptyItemName="'Project'" v-bind:noItemTitle="$t('aucunProjet')" v-bind:c2aTxt="$t('créezVotrePremierProjetPourCommencer')" ></empty-view-bloc-comp>

        <!--  Bloc placeholder affiché pendant le chargement des timerecords-->
        <div class="appBloc" id="blocLoadingProjects" v-if="!componentIsReady">
            <table class="table is-fullwidth">
                <tbody>
                <loading-timerecord-comp v-for="index in 10" :key="index"></loading-timerecord-comp>
                </tbody>
            </table>
        </div>

        <!-- liste des projets -------------------------------------------->
          <div v-else-if="projectCount > 0" >
              <div class="table-container"> <!-- rend le tableau scrollable si besoin (pour les mobiles)-->
                <table class="appBloc table is-fullwidth project" id="projectTable">

                <thead>
                <tr class="lineProject">
                    <th colspan="" class="theadProject is-uppercase">{{$t('projet')}}</th>
                    <th colspan="" class="theadProject is-uppercase"></th>
                    <th colspan="" class="is-uppercase ">{{$t('TempsPassé')}}</th>
<!--                    <th colspan="" class="is-uppercase ">{{$t('DateCréation')}}</th>-->
                    <th colspan="" class="is-uppercase ">{{$t('Client')}}</th>
                    <th colspan="" class="is-uppercase is-hidden-touch is-hidden-desktop-only">{{$t('Propriétaire')}}</th>

                  <!--                    <th colspan="" class="is-uppercase">{{$t('accès')}}</th>-->
                    <th colspan="" class="is-uppercase is-hidden-touch is-hidden-desktop "> {{$t('archivage')}}</th>
                    <th colspan="" class="is-uppercase "></th>
                </tr>
                </thead>

                <tbody >
                <tr v-for="(project,index) in projects" v-bind:key="project.slug"  v-bind:id="'project_'+project.slug" v-bind:class="'project_'+index">

                  <td class="projectName">
                        <span v-if="project.isArchived" v-bind:title="$t('leProjetEstArchivé')">
                            <font-awesome-icon  class="icon archivedProject" :icon="['fas', 'folder']" />
                        </span>
                        <span v-else>
                            <font-awesome-icon  v-bind:style="{color:'#'+ project.color}" class="icon" :icon="['far', 'folder-open']" />
                        </span>


                    <!--// Lien vers dashboard si l'user a la permission d'édition -->
                       <router-link v-if="$auth.hasRole('ROLE_ADMIN')" v-bind:to="{ name: 'project-details', params: {project:project.slug}}" class="name">{{project.name}}</router-link>

                        <!--// affichage du nom du projet si l'user n'a pas de permission d'édition -->
                        <span v-else  class="name" v-bind:class="{'archivedProject':project.isArchived}">{{project.name}}</span>

                    </td>
                  <td class="dashboardLink">
                    <router-link v-if="$auth.hasRole('ROLE_ADMIN')" v-bind:to="{ name: 'project-details', params: {locale: $route.params.locale,project:project.slug}}"
                                 class="button cronoBtn invert dashboardBtn">
                      <span class="">
                        <font-awesome-icon class="icon" :icon="['fas', 'tachometer-alt']"/>
                      </span>
                      <span>{{ $t('TableauDeBord') }}</span>
                    </router-link>

                    <a v-else class="button cronoBtn invert dashboardBtn" style="cursor:not-allowed"
                       v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', trigger:'click'}"
                       :content="$t('vousDevezAvoirLeStatutAdministrateurPourAccéderAuTableauDeBord')"
                        >
                      <span class="">
                        <font-awesome-icon class="icon" :icon="['fas', 'tachometer-alt']"/>
                      </span>
                      <span>{{ $t('TableauDeBord') }}</span>
                    </a>
                  </td>

                  <td class="duration">


                    <div class="progressBarCont" v-bind:class="colorByPercent(project)"
                         v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip'}"
                         :visible="false"
                         :content="
                         project.estimate != null ?
                            $t('tooltip-leProjetXAConsomméXHeuresSurXPrévues', {project : project.name, percent:calculateProjectPercent(project) , duration: formatDurationInHourAndMin($moment.duration(project.duration), $moment,locale)})
                          : $t('tooltip-aucunTempsPrévu') "
                         >

                        <span class="spent" v-bind:title="$t('TempsPassé')">
                      {{ formatDurationInHourAndMin($moment.duration(project.duration), $moment, locale) }}
                    </span>

                      <span class="estimate" v-if="project.estimate != null">
                        /
                        {{ project.estimate }} h</span>

                      <span class="percent"
                            v-bind:class="colorByPercent(project)">{{ calculateProjectPercent(project) }} %</span>

                      <progress class="progress" v-bind:class="colorByPercent(project)"
                                v-bind:value="calculateProjectPercent(project)" max="100">
                        {{ calculateProjectPercent(project) }}%
                      </progress>
                    </div>
                  </td>

<!--                    <td class="createdAt " v-bind:title="$t('DateCréation')">{{$moment(project.createdAt).fromNow()}}</td>-->


                    <td class="clientName ">
                        <span v-if="project.client != null">
                            <font-awesome-icon class="icon" :icon="['fas', 'user-tie']" />
                            {{project.client.name}}
                        </span>
                        <span v-else>-</span>
                    </td>

                  <td class="owner is-hidden-touch is-hidden-desktop-only">
                        <span class="fullname">
                            {{project.owner.firstname + ' ' + project.owner.name}}
                        </span>
                  </td>

<!--                    <td class="isPrivate ">-->
<!--                        <span v-if="project.isPrivate" class="private">-->
<!--                           <font-awesome-icon class="icon" :icon="['fas', 'lock']" />-->
<!--                            {{$t('privé')}}-->
<!--                        </span>-->
<!--                        <span v-else class="public">-->
<!--                            <font-awesome-icon  class="icon" :icon="['fas', 'lock-open']" />-->
<!--                            {{$t('public')}}-->
<!--                        </span>-->
<!--                    </td>-->

                    <td class="isArchived  is-hidden-touch is-hidden-desktop ">
                        <span class="tagArchived"  v-if="project.isArchived">
                            <font-awesome-icon  class="icon" :icon="['fas', 'folder']" />
                            {{$t('archivé')}}
                        </span>
                        <span v-else>{{'-'}}</span>
                    </td>

                    <td class="menuLink" v-bind:title="$t('afficherLeSousMenu')">
                        <font-awesome-icon
                                v-if="userCanEditProject(project)"
                                v-bind:id="'menuOpener_'+project.slug"
                                v-on:click="showMenu(index)" class="icon menuOpener"
                                :icon="['fas', 'ellipsis-v']"/>
                    </td>

                    <div class="menu" v-show="project.showMenu" v-on:mouseleave="hideMenus()">
                        <ul>
                            <li v-on:click="modifyProject(project)" class="editLink">
                                <font-awesome-icon class="icon" :icon="['fas', 'pencil-alt']"/>
                                <a>{{$t('modifier')}}</a>
                            </li>

                            <li class="unArchiveLink" v-if="project.isArchived" v-on:click="archiveProject(project,'restore')">
                                <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                <a >{{$t('désarchiver')}}</a>
                            </li>
                            <li  class="archiveLink" v-else v-on:click="archiveProject(project,'archive')">
                                <font-awesome-icon class="icon" :icon="['fas', 'folder']"/>
                                <a  >{{$t('archiver')}}</a>
                            </li>

                            <li class="deleteLink" v-bind:id="'deleteLink_'+project.slug"
                            >
                                <font-awesome-icon class="icon" :icon="['fas', 'trash-alt']"/>
                                <a v-on:click="openModalDeleteProject(project)">{{$t('supprimer')}}</a>
                            </li>
                        </ul>
                    </div>
                </tr>

                </tbody>
            </table>
              </div>
         </div>

    </div>

<!--    https://www.npmjs.com/package/v-click-outside-->
<!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    import ProjectMixin from "../mixins/ProjectMixin.js";
    import LoadingTimerecordComp from "./PlaceholderTimerecordComp";

    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import _ from 'lodash'
    import EmptyViewBlocComp from "@/components/EmptyViewBlocComp";
    import TimeMixin from "@/mixins/TimeMixin";
    import TrackingMixin from "@/mixins/TrackingMixin";

    // import vClickOutside from 'v-click-outside'

    export default {
        name: 'ProjectListComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin, TimeMixin, ProjectMixin, TrackingMixin],
        components: {EmptyViewBlocComp, LoadingTimerecordComp},

        // directives: {
        //     clickOutside: vClickOutside.directive
        // },

        // props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            // placeholder : String, // attribut placeholder du champ
        // },
        data: function () {
            return {
                locale : this.$route.params.locale,
                // pour les composants où l'user est identifié ///////////////////////
                organizationSlug: this.$route.params.organization,
                userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
                componentIsReady : false, // indique quand le composant est prêt à être affiché (projets chargés)
                projectCount : 0, // le nombre total de projets dans la vue
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                projects: state => state.ProjectsView.projects,
                themeToDisplay: state => state.app.themeToDisplay

            }),

            //----------------------------------------------

            // vuex 2-way data binding forms https://vuex.vuejs.org/guide/forms.html#two-way-computed-property
            // email: {
            //     get () {return this.$store.state.user.email},
            //     set (value) {this.$store.commit('UpdateUserEmail', value)}
            // },

            //----------------------------------------------

            // other computed props :


        },
        watch: {
            // Chargement initial des projets : on a besoin d'attendre que user soit récupéré dans le store pour charger les projets (slug user requis dans la route)
            user: function () {
                if (this.user != null) {
                    this.loadProjects()
                }
            },
          projects :  function (){ // maj le nombre de projet quand les projets sont modifiés
              this.projectCount = this.projects.length
          }
        },


        methods: {

            /**
             * Met le store à jour avec editedProject
             * @param editedProject object le projet mis à jour à mettre dans le store
             * inspiré de https://stackoverflow.com/questions/27641731/is-there-a-function-in-lodash-to-replace-matched-item
             *
             */
        updateProjectInStore(editedProject){
            // on remplace le projet édité dans le store

            // Trouve l'index de l'objet à remplacer dans le store
            var index = _.findIndex(this.projects, {slug: editedProject.slug});

            editedProject.showMenu = false // on définit l'affichage du .menu à false

            // Remplace l'objet à l'index précédemment trouvé
            this.projects.splice(index, 1, editedProject);

        },

            /**
             * Ajoute un projet dans le store.
             * Utilisé pour maj le dom après la création d'un projet.
             * @param project2Add object le projet à ajouter dans le store
             *
             */
            addProjectInStore(project2Add){
                let projectsInStore =  this.projects
                // on ajoute le projet au début du tableau (car loadProject() charge en desc)
                project2Add.showMenu = false // on initialise l'affichage du .menu à false

                projectsInStore.unshift(project2Add)
                this.$store.commit('UpdateProjectsViewProjects', projectsInStore)
            },

            /**
             * Supprime un projet dans le store.
             * Utilisé pour maj le dom après la suppression d'un projet.
             * @param project2Del object le projet à supprimer dans le store
             *
             */
            removeProjectInStore(project2Del){
                // Trouve l'index de l'objet à modifier dans le store
                var index = _.findIndex(this.projects, {slug: project2Del.slug});
                project2Del.showMenu = false // on réinit l'affichage du .menu à false (oui l'élément est supprimé mais un autre a pu prendre sa place) @todo améliorer car imparfait

                // supprime l'objet à l'index précédemment trouvé
                this.projects.splice(index, 1);
            },

            /**
             * Récupère les projets accessibles pour l'utilisateur.
             *
             * @param String filter | une chaîne pour filtrer par nom des projets ET clients
             */
            loadProjects(filter) {
                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.userSlug}/projects`,
                    {
                        params: {
                            filter: filter,
                            sort: 'desc', // on récupère les plus récents en premier
                            archive: 'all', // on récupère les projets archivés + actifs
                            withDuration: '', // on récupère les durées des projets
                        },
                        headers: {Authorization: self.$auth.header()},
                        timeout: 20000 // surcharge timeout car la requête a tendance à prendre du temps @todo à améliorer à terme ?

                    }
                )
                    .then(function (response) {
                       self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on injecte une propriété 'showMenu' dans chaque projets (qui sert à gérer l'affichage des .menu)
                        let projects = []
                        response.data.forEach(function (value) {
                            value.showMenu = false;
                            projects.push(value);
                        })

                        // stockage dans le store
                        self.$store.commit('UpdateProjectsViewProjects', response.data)
                        self.componentIsReady = true

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0029'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$mixpanel.track('global error displayed', {"id": errorCode,"detail": "error fetching projects"})
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching projects', 'fatal': false})

                          self.$sentry.captureMessage(`Error ${errorCode} > "error fetching projects : ${error}`, 'error')
                        }
                    })
                    .then(() => {
                        // toujours exécuté
                    })
            },


            /**
             * Masque tous les éléments .menu
             **/
            hideMenus() {
                this.projects.forEach(function (value) {
                    value.showMenu = false;
                })
            },
            /**
             * Affiche l'élément .menu dont index est passé.
             * @param index int | Index du menu à afficher
             */
            showMenu(index) {
                this.hideMenus(); // on masque un éventuel .menu affiché au préalable
                this.projects[index].showMenu = true;
            }

            /**
             * Ouvre la modal project management pour modifier un projet
             * @param projectToModify L'objet Projet à modifier
             */
            , modifyProject(projectToModify) {
                this.$root.$emit('show_modal_project_management','edition', projectToModify)
            }

            /**
             * Archive/restaure un projet
             * @param projet Object projet à archiver
             * @param mode String L'action à effectuer (archive/restore)
             */
            ,archiveProject(project,mode){

                const params = {}
                switch (mode) {
                    case  'archive': params.isArchived= true; break;
                    case  'restore': params.isArchived= false; break;
                }

                let self = this
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/projects/${project.slug}`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                        // on maj le store avec le projet modifié
                        self.updateProjectInStore(response.data)

                        // tracking
                        self.$mixpanel.track("Project archived", {"timerecord":response.data.slug});
                        self.ga4GlobalEventTrack('Project archived' , {})
                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                          self.logToSentry(self, error, 'error')
                          let errorCode = '0030' ; let msg = "error archiving project";
                          self.showGlobalErrorNotif(self,errorCode)
                          self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": msg})
                          self.$gtag.exception({'description': 'error '+errorCode + ' | ' +msg, 'fatal': false})
                          self.$sentry.captureMessage(`Error ${errorCode} > ${msg}: ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            }

            /**
             * Déclenche l'ouverture de la ModalDeleteProjectComp
             * @param projet Object projet à supprimer
             */
            ,openModalDeleteProject(project){
                this.$root.$emit('show_modal_delete_project',project)
            }


            /**
             * Retourne true si l'utilisateur actuel à le droit de modifier le projet
             * @param project Object | le projet à tester
             * @return {boolean}
             */
            ,userCanEditProject(project){
                // Pour modifier un Project il faut être le owner du projet
                if(project.owner.slug == this.$auth.getUserSlug()){
                    return true
                }
                // ...OU être ROLE_ADMIN dans la même organization
                else if(this.$auth.hasRole('ROLE_ADMIN') && this.$auth.getOrganization() == this.organizationSlug){
                    return  true
                }

            },
        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            // NOTE : Le chargement initial des projets sera effectué via le watch une fois que this.user aura été hydraté ( car le slug de l'user est requis dans la route) | Il faut tout de même charger ici pour fixer le bug #332 (https://gitlab.com/ousmane1/kronocloud/-/issues/332)
            this.loadProjects()

            // listener de l'event new_project_added, pour m.a.j les projets si un projet est ajouté
            this.$root.$on('new_project_added', (projectAdded) => {
                this.addProjectInStore(projectAdded)
            })

            // listener de l'event project_edited, pour m.a.j les projets si un projet est modifié
            this.$root.$on('project_edited', (projectEdited) => {
               this.updateProjectInStore(projectEdited)
            })
            // listener de l'event project_deleted, pour m.a.j les projets si un projet est supprimé
            this.$root.$on('project_deleted', (projectEdited) => {
               this.removeProjectInStore(projectEdited)
            })

        }
        ,beforeDestroy() {
          /**
           * Fix un potentiel bug d'insertion du projet en double après création https://gitlab.com/ousmane1/kronocloud/-/issues/251
           * N'a pas réellement pu être rerpoduit en dev donc à voir si le problème persiste
           * inspiré de : https://stackoverflow.com/a/61049328/666416 | https://charlietheprogrammer.com/duplicate-vue-event-listeners-and-how-i-solved-them
           **/
          this.$root.$off('new_project_added', () => {
          })
        },
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";

    #ProjectListComp{

    /////////////////////////////////////////
    // LIGHT THEME ///////////////////////////
    table.project{



        .theadProject{
            /*padding-left: 1rem;//surtout pour mobile*/
        }

        .icon{
            padding-top: 0.5rem;
            margin-right: 0.4rem;
        }

        .projectName{
          //background-color: red;
          min-width: $variableTxtMinWidth; // @todo voir pour faire sur les autre columns dont la tailel varie beacoup
            padding-left: 2rem;
            @include mobile{
                padding-left: 1rem;
            }
            font-weight: bold;

            .name {
                color: #666;
                &.archivedProject {
                    color: lighten($darkBg,10%) !important;
                }
            }

            .icon{
                &.archivedProject {
                    color:lighten($darkBg,10%) !important;
                }
            }

        }
      .dashboardLink{
        .button{
          border: solid 1px #ddd;
          margin-left: 2rem;
          padding: 1.2rem .8rem ;
          font-size: .85rem;
          //font-weight: bold;
          //color:$brandFourth
          transition: box-shadow .3s, color .3s, border-color .3s;

          color:$brandFourth;
          .icon{
            color:$brandPrimary;
            $size: 1.5rem; width:$size; height: $size;
          }
          &:hover{
            box-shadow: 0 0 3px #ccc;
            color:$brandThird;
          }
          &:active{
            box-shadow: 0 0 3px #ccc;
            color:$brandThird;
            border-color: $brandFourth;
            transition: border-color 70ms;

          }
        }
      }
        .owner{
            .fullname{
                text-transform: capitalize;
            }
        }
      .duration{
        //min-width: 4rem;
        //padding: .4rem;
        //background-color: red;
        padding-right: .6rem;
        padding-left: 1rem;

        .progressBarCont{
          $progressBgColor: #ddd;

          //display: flex;
          position: relative;
          margin-right: 1.5rem;


          @include touch(){
            //background-color: red;
            min-width: 9rem;
          }

          .under70{color: $brandPrimary !important;}
          .under100{color:$brandOrange !important;}
          .over100{color:$brandRed !important;}
          .spent{
            display: inline-block;
            border-radius: .5rem;
            font-weight: bold;
          }

          .estimate{
            border-radius: .5rem;
            display: inline-block;
            margin: 0 .5rem;
          }


          .percent{
            font-weight: bold;
            position: absolute;
            right: 0;
            color: $progressBgColor;
          }

          .progress {

            display: block;
            margin-top: .2rem;
            border: none;
            max-height: .3rem;

            // couleur de fond de la progress bar
            &::-webkit-progress-bar {background-color: $progressBgColor;} // chromium
            background-color: $progressBgColor; // firefox


            &.under50 { // couleur : vert
              &::-webkit-progress-value {background-color: $brandPrimary;}
              &::-moz-progress-bar { background: $brandPrimary; }
              color: $brandPrimary; // ie 10
            }


            &.under70 { // couleur vert jusqu'à 50% orange à 70%
              $gradient :linear-gradient(90deg,$brandPrimary 80%, $brandOrange 100%);
              &::-webkit-progress-value {background: $gradient}
              &::-moz-progress-bar { background: $gradient; }
              color: $gradient; // ie 10
            }

            &.under100 { // couleur :  vert jusqu'à 50% orange à 70% rouge à 90%
              $gradient : linear-gradient(90deg,$brandPrimary 50%, $brandOrange 80%);
              &::-webkit-progress-value {background:$gradient}
              &::-moz-progress-bar { background: $gradient; }
              color: $gradient; // ie 10
            }

            &.over100 {
              $gradient:  linear-gradient(90deg ,$brandOrange 5%, $brandRed 90%);
              &::-webkit-progress-value {background: $gradient;}
              &::-moz-progress-bar { background: $gradient; }
              color: $gradient; // ie 10
            }
          }
        }
      }
        .clientName{
            min-width: $variableTxtMinWidth;
            font-weight: bold;
            color: $clientColor;
        }
        .isPrivate{
                .private{
                    color:$brandThird;
                    &.icon{
                        color:$brandThird;
                    }
                }
                .public{
                    color:#999;
                    &.icon{
                        color:#999
                    }
                }
        }
        .menuLink{
            padding: 0;
          //background-color: red;


            .icon{
                /*border:dashed 1px lightblue;*/
                cursor: pointer;
                margin-left: .2rem;
                font-size: 1.2rem;

                @include mobile{
                    margin: 0.9rem 2rem 0 1.5rem;
                }
                color:#ccc;

                &:hover{
                    color:$brandPrimary
                }


            }

        }
        .tagArchived{
            background:$brandYellow;
            padding: 0.3rem 0.5rem;
            border-radius: 3px;
            font-size: 0.85rem;
            color:#666;
            display: inline-block;
            min-width: 5.5rem;
          .icon{
            padding: 0;
            vertical-align: middle;
          }
        }
    }

    /////////////////////////////////////////
    // DARK THEME ///////////////////////////
      &.darkMode {
        .projectName{
          .name{color:$darkContrastTxt !important;
            &.archivedProject {
              color:$disabledTableItemColor !important;
            }
          }
          .icon{
            &.archivedProject {
              color:$disabledTableItemColor !important;
            }
          }
        }
        .dashboardLink{
          .button{
            border-color: lighten($darkBg,10%) !important;
            color:$darkTxt !important;
            .icon{
              color: $darkLightBlue !important;
            }
            &:hover{
              box-shadow:none !important;
              color:$darkLightBlue !important;
            }
            &:active{
              color:$brandThird;
              border-color: $darkLightBlue !important;
            }
          }
        }

        .duration{
          span{
            color:$darkTxt !important;
          }

          .progressBarCont{

            .estimate{
              color: $brandFourth !important;

            }
            .percent{
              color: lighten($darkBg,10%) !important;
            }

            .progress {
              // couleur de fond de la progress bar
              &::-webkit-progress-bar {background-color: lighten($darkBg,7%) !important;} // chromium
              background-color:  lighten($darkBg,7%) !important; // firefox

            }
          }

        }
        .isPrivate{
          .private{color:$darkLightBlue !important;}
        }

        .tagArchived{
          background-color: $darkTxt !important;
          color:$darkBg !important;
        }

      }
    }


</style>
